
import { /* React, */ useState } from 'react';
import { SearchComponent } from './SearchComponent';
import { SessionsList } from './SessionsList';
import { useTrainingJournal } from '../context/useTrainingJournal';

// interface TabsComponentProps {
//   techniquesContent?: React.ReactNode;
// }

export function TabsComponent() {
  const [searchQuery, setSearchQuery] = useState('');
  const { sessions } = useTrainingJournal();
  
  return (
    <div className="space-y-4">
      {/* Search component */}
      <div className="mb-4">
        <SearchComponent
          value={searchQuery}
          onChange={setSearchQuery}
          placeholder="Search sessions..."
        />
      </div>
      
      {/* Sessions list - pass searchQuery to enable filtering */}
      <SessionsList 
        sessions={sessions} 
        searchQuery={searchQuery}
        title="Training Sessions"
        emptyMessage="No training sessions found"
      />
    </div>
  );
}
